import React from 'react';
import PropTypes from 'prop-types';
import { Icon } from './../icon';
import cx from 'classnames';
import './loadMore.css';

const LoadMore = props => {
  const onClick = (e) => {
    e.preventDefault();
    if (props.show) {
      props.onClick();
    }
  };

  return (
    <a
      href=""
      className={cx('load-more', { 'load-more-hidden': !props.show })}
      onClick={onClick}
    >
      Viac <Icon name="chevron-circle-right" />
    </a>
  );
};

LoadMore.defaultProps = {
  onClick: () => { },
  show: true,
};

LoadMore.propTypes = {
  onClick: PropTypes.func,
  show: PropTypes.bool,
};

export default LoadMore;



// WEBPACK FOOTER //
// ./src/ui/src/component/loadMore/loadMore.js